import { Box, Container, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { ContentWrapper } from "../components/layout/ContentWrapper";
import { AnimatedView } from "../components/utils/AnimatedView";
import { BottomActionBar } from "../components/utils/BottomActionBar";
import { ExternalLink } from "../components/utils/ExternalLink";
import { routes } from "../constants/routes";
import { ContentfulContext } from "../context/ContentfulContext";
import { References } from "../models/schema";

const ReferencesPage = () => {
  const { content } = useContext(ContentfulContext);
  const references = content?.references as References;
  const {
    title,
    publicSectorLabel,
    publicSectorCollection,
    privateSectorLabel,
    privateSectorCollection,
    partnershipLabel,
    partnershipCollection,
    bottomBannerLabel,
    bottomBannerAction
  } = references;

  return (
    <>
      <ContentWrapper
        title={title as string}
        sx={{
          mb: { xs: 5, md: 10 }
        }}>
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 5
          }}>
          <Box>
            <Typography variant="h3" mb={3}>
              {publicSectorLabel}
            </Typography>
            <Grid container spacing={2}>
              {publicSectorCollection?.items
                .filter((item) => !!item)
                .map((item, index) => (
                  <Grid item xs={6} md={4} lg={3} key={index}>
                    <AnimatedView animation="fadeIn">
                      {item?.url ? (
                        <ExternalLink href={item.url} target="_blank" rel="noopener noreferrer">
                          <Box
                            component="img"
                            src={item?.logo?.url as string}
                            sx={{ height: { xs: "4rem", md: "6rem" }, p: 3 }}
                          />
                        </ExternalLink>
                      ) : (
                        <Box
                          component="img"
                          src={item?.logo?.url as string}
                          sx={{ height: { xs: "4rem", md: "6rem" }, p: 3 }}
                        />
                      )}
                    </AnimatedView>
                  </Grid>
                ))}
            </Grid>
          </Box>

          <Box>
            <Typography variant="h3" mb={3}>
              {privateSectorLabel}
            </Typography>
            <Grid container spacing={2}>
              {privateSectorCollection?.items
                .filter((item) => !!item)
                .map((item, index) => (
                  <Grid item xs={6} md={4} lg={3} key={index}>
                    <AnimatedView animation="fadeIn">
                      {item?.url ? (
                        <ExternalLink href={item.url} target="_blank" rel="noopener noreferrer">
                          <Box
                            component="img"
                            src={item?.logo?.url as string}
                            sx={{ height: { xs: "4rem", md: "6rem" }, p: 3 }}
                          />
                        </ExternalLink>
                      ) : (
                        <Box
                          component="img"
                          src={item?.logo?.url as string}
                          sx={{ height: { xs: "4rem", md: "6rem" }, p: 3 }}
                        />
                      )}
                    </AnimatedView>
                  </Grid>
                ))}
            </Grid>
          </Box>

          <Box>
            <Typography variant="h3" mb={3}>
              {partnershipLabel}
            </Typography>
            <Grid container spacing={2}>
              {partnershipCollection?.items
                .filter((item) => !!item)
                .map((item, index) => (
                  <Grid item xs={6} md={4} lg={3} key={index}>
                    <AnimatedView animation="fadeIn">
                      {item?.url ? (
                        <ExternalLink href={item.url} target="_blank" rel="noopener noreferrer">
                          <Box
                            component="img"
                            src={item?.logo?.url as string}
                            sx={{ height: { xs: "4rem", md: "6rem" }, p: 3 }}
                          />
                        </ExternalLink>
                      ) : (
                        <Box
                          component="img"
                          src={item?.logo?.url as string}
                          sx={{ height: { xs: "4rem", md: "6rem" }, p: 3 }}
                        />
                      )}
                    </AnimatedView>
                  </Grid>
                ))}
            </Grid>
          </Box>
        </Container>
      </ContentWrapper>
      <BottomActionBar
        actionLabel={bottomBannerAction as string}
        title={bottomBannerLabel as string}
        route={routes.contact}
      />
    </>
  );
};

export default ReferencesPage;
